const HeroSlider = ($) => {
	$(document).ready(function () {
		$("#hero-slider").slick({
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 1500,
			speed: 1500,
			fade: true,
			prevArrow: false,
			nextArrow: false,
			cssEase: "ease-in-out",
			dots: false,
		});
	});
};

export default HeroSlider;
